module.exports = __webpack_public_path__ + "img/prize-03-icon.086b542d.png";